<template>
    <a
        v-if="urlInfo"
        :href="urlInfo.link"
        target="_blank"
        class="box media my-2"
    >
        <figure v-if="urlInfo.image" class="media-left">
            <p class="image is-64x64">
                <img :src="urlInfo.image.url" />
            </p>
        </figure>
        <div class="media-content">
            <div class="content">
                <p>
                    <strong>{{ urlInfo.title }}</strong>
                    <br />
                    <small>{{ urlInfo.source }}</small>
                    <br />
                    {{ urlInfo.description }}
                </p>
            </div>
        </div>
    </a>
</template>

<script>
import { getURLMetadata } from '@/services/API';
export default {
    name: 'AppURLPreview',
    props: {
        url: {
            type: String,
            default: undefined,
        },
    },
    data() {
        return {
            urlInfo: undefined,
        };
    },
    mounted() {
        getURLMetadata(this.url).then(({ data }) => {
            if (data.success) {
                this.urlInfo = data.meta;
            }
        });
    },
};
</script>

<style></style>
